"use client";
import { FC } from "react";

import { useParams } from "next/navigation";
import GroupsSlider from "./GroupsSlider";
import {
  ALL_GAMES_SLUG,
  CASINO_DATA_SOURCE,
  CASINO_POPULAR_GAMES_DATA_SOURCE,
  CASINO_SPECIAL_GROUPS,
  LIVE_CASINO_DATA_SOURCE,
} from "@/config/casino";
import LiveGroupsSlider from "./LiveGroupsSlider";
import { usePathname } from "../../navigation";
import Search from "../NavPage/Search";

const CasinoGroupNavigation: FC = () => {
  const pathname = usePathname() ?? "";
  const isLive = pathname.includes("/casino/live");
  const params = useParams();

  // useEffect(() => {
  //   dispatch(navRequest("casino"));
  //
  //   return () => {
  //     dispatch(clearNav());
  //   };
  // }, [dispatch]);
  //
  // useEffect(() => {
  //   const firstSelection: string | null = localStorage.getItem(
  //     localStorageKeys.FIRST_SELECTION
  //   );
  //
  //   if (!firstSelection) {
  //     localStorage.setItem(localStorageKeys.FIRST_SELECTION, "casino");
  //     localStorage.setItem(
  //       localStorageKeys.FIRST_SELECTION_DATE,
  //       dayjs().toISOString()
  //     );
  //   }
  // }, [dispatch]);

  const getSlider = () => {
    if (isLive) {
      const dataSource = LIVE_CASINO_DATA_SOURCE;
      const groupId = params?.group
        ? `${dataSource}$${params?.group ?? null}`
        : null;

      return (
        <LiveGroupsSlider
          groupId={
            pathname === "/casino/live/all-games"
              ? `casino$${ALL_GAMES_SLUG}`
              : groupId
          }
        />
      );
    } else {
      if (CASINO_SPECIAL_GROUPS[pathname]) {
        return <GroupsSlider groupId={CASINO_SPECIAL_GROUPS[pathname]} />;
      }
      const dataSource =
        params?.group === "popular"
          ? CASINO_POPULAR_GAMES_DATA_SOURCE
          : CASINO_DATA_SOURCE;
      const groupId = params?.group
        ? `${dataSource}$${params?.group ?? null}`
        : null;

      return <GroupsSlider groupId={groupId} />;
    }
  };
  return (
    <div className="flex   items-center justify-between container w-full mt-6 sm:mt-10">
      {getSlider()}
      <Search isLive={!!isLive} />
    </div>
  );
};

export default CasinoGroupNavigation;
